import React from 'react';
import { Link } from 'react-router-dom';
import { getImageUrl, formatCourseUrl } from '../utils/helpers';

// Simple course card for trending section - matches mobile app design
// Mobile app shows only image + course name in 3-column grid
const TrendingCourseCard = ({ course }) => {
  const courseName = course.course_name || course.sub_name || course.name;
  // Use course ID for navigation, matching mobile app
  const courseUrl = `/course/${course.id}`;
  
  // Check if course is purchased (matching mobile app logic)
  const isPurchased = course.purchased === 'Credit';

  return (
    <Link 
      to={isPurchased ? `/subjects/${course.id}` : courseUrl}
      state={isPurchased ? {
        type: course.type,
        id: course.id,
        subject: course.sub_name || course.course_name,
        flag: 0, // 0 means purchased
        viewType: course.viewType
      } : undefined}
    >
      <div className="bg-white rounded-lg overflow-hidden shadow-md hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1">
        {/* Course Image */}
        <div className="relative aspect-square overflow-hidden bg-gray-100">
          <img 
            src={getImageUrl(course.images)} 
            alt={courseName}
            className="w-full h-full object-cover hover:scale-110 transition-transform duration-300"
            onError={(e) => {
              e.target.src = `${process.env.REACT_APP_BASE_URL}/assets/images/placeholder.jpg`;
            }}
          />
          {/* Purchased Badge */}
          {isPurchased && (
            <div className="absolute top-2 right-2 bg-green-500 text-white px-2 py-1 rounded-full text-xs font-bold shadow-lg">
              ✓ Purchased
            </div>
          )}
        </div>
        
        {/* Course Name */}
        <div className="p-3">
          <h3 className="text-sm sm:text-base font-bold text-gray-800 text-center line-clamp-2 hover:text-blue-600 transition">
            {courseName}
          </h3>
        </div>
      </div>
    </Link>
  );
};

export default TrendingCourseCard;

